const withdrawalActionTypes = {
    FETCH_WITHDRAWALS_START: 'FETCH_WITHDRAWALS_START',
    FETCH_WITHDRAWALS_SUCCESS: 'FETCH_WITHDRAWALS_SUCCESS',
    FETCH_WITHDRAWALS_FAILURE: 'FETCH_WITHDRAWALS_FAILURE',
    CREATE_WITHDRAWAL_START: 'CREATE_WITHDRAWAL_START',
    CREATE_WITHDRAWAL_SUCCESS: 'CREATE_WITHDRAWAL_SUCCESS',
    CREATE_WITHDRAWAL_FAILURE: 'CREATE_WITHDRAWAL_FAILURE'
};

export default withdrawalActionTypes;
